import { render } from "./DashboardQuickSettings.vue?vue&type=template&id=e7a6779c"
import script from "./DashboardQuickSettings.vue?vue&type=script&lang=js"
export * from "./DashboardQuickSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__